import { useEffect, useState } from "react";
import { LineChartDetailsCardReport } from "../../lineChartCard/index2";

export const LineChartCardReport = ({ dataToChart, height, key, type, local, sensorName }) => {

    const [datasets, setDatasets] = useState([]);
    const [loadingChart, setLoadingChart] = useState(true);

    useEffect(() => {
        if (type === "all" && sensorName === 'temperatureFarm') {
            setDatasets([
                {
                    label: 'Temp P',
                    data: dataToChart.sensor1Values,
                    borderColor: 'rgba(246, 167, 104)',
                    backgroundColor: 'rgba(246, 167, 104, 0.7)',
                    lineTension: 0.2,
                    borderWidth: 2,
                    pointStyle: 'line',
                    spanGaps: false,
                },
                {
                    label: 'Temp S',
                    data: dataToChart.sensor2Values,
                    borderColor: 'rgba(246, 167, 104)',
                    backgroundColor: 'rgba(246, 167, 104, 0.7)',
                    borderDash: [5, 5],
                    lineTension: 0.5,
                    borderWidth: 2,
                    spanGaps: false,
                    pointStyle: 'dash',
                },
                {
                    label: "Temp M",
                    data: dataToChart.sensor4Values,
                    borderColor: 'rgba(255, 112, 0)',
                    backgroundColor: 'rgba(255, 112, 0, 0.5)',
                    lineTension: 0.5,
                    borderWidth: 2,
                    spanGaps: false,
                    pointStyle: 'line',
                },
                {
                    label: "Temp E",
                    data: dataToChart.sensor3Values,
                    borderColor: 'rgba(255, 62, 62)',
                    backgroundColor: 'rgba(255, 62, 62, 0.5)',
                    lineTension: 0.5,
                    borderWidth: 2,
                    spanGaps: false,
                    pointStyle: 'line',
                },

                {
                    label: 'Limite Inf',
                    data: dataToChart.sensorMaxThresholdValues,
                    borderColor: 'rgba(255, 0, 0)',
                    backgroundColor: 'rgba(255, 0, 0)',
                    borderDash: [15, 3, 3, 3],
                    showLine: true,
                    lineTension: 0.5,
                    borderWidth: 0.6,
                    spanGaps: false,
                    pointStyle: false,

                },
                {
                    label: 'Limite Sup',
                    data: dataToChart.sensorMinThresholdValues,
                    borderColor: 'rgba(255, 0, 0)',
                    backgroundColor: 'rgba(255, 0, 0)',
                    borderDash: [15, 3, 3, 3],
                    showLine: true,
                    lineTension: 0.5,
                    borderWidth: 0.6,
                    spanGaps: false,
                    pointStyle: false,

                },
            ]);
        } else if (sensorName === "humidityFarm") {
            setDatasets([
                {
                    label: 'Umid P',
                    data: dataToChart.sensor1Values,
                    borderColor: 'rgb(122, 140, 255)',
                    backgroundColor: 'rgba(122, 140, 255, 0.5)',
                    lineTension: 0.5,
                    borderWidth: 2,
                    pointStyle: 'line',
                    spanGaps: false,
                },
                {
                    label: 'Umid S',
                    data: dataToChart.sensor2Values,
                    borderColor: 'rgb(122, 140, 255)',
                    backgroundColor: 'rgba(122, 140, 255, 0.5)',
                    borderDash: [5, 5],
                    lineTension: 0.5,
                    borderWidth: 2,
                    spanGaps: false,
                    pointStyle: 'dash',
                },
                {
                    label: 'Umid M',
                    data: dataToChart.sensor3Values,
                    borderColor: 'rgba(0, 35, 255)',
                    backgroundColor: 'rgba(0, 35, 255, 0.5)',
                    lineTension: 0.5,
                    borderWidth: 2,
                    spanGaps: false,
                    pointStyle: 'line',
                },
                {
                    label: 'Limite Inf',
                    data: dataToChart.sensorMaxThresholdValues,
                    borderColor: 'rgb(0, 91, 180)',
                    backgroundColor: 'rgba(0, 91, 180)',
                    borderDash: [15, 3, 3, 3],
                    showLine: true,
                    lineTension: 0.5,
                    borderWidth: 0.6,
                    spanGaps: false,
                    pointStyle: false,

                },
                {
                    label: 'Limite Sup',
                    data: dataToChart.sensorMinThresholdValues,
                    borderColor: 'rgb(0, 91, 180)',
                    backgroundColor: 'rgba(0, 91, 180)',
                    borderDash: [15, 3, 3, 3],
                    showLine: true,
                    lineTension: 0.5,
                    borderWidth: 0.6,
                    spanGaps: false,
                    pointStyle: false,

                },
            ]);
        } else if (sensorName === "co2Farm") {
            setDatasets([
                {
                    label: 'CO2',
                    data: dataToChart.sensor1Values,
                    borderColor: 'rgba(0, 179, 52, 0.3)',
                    backgroundColor: 'rgba(0, 179, 52, 0.3)',
                    lineTension: 0.5,
                    borderWidth: 2,
                    pointStyle: 'rect',
                    spanGaps: false,
                    fill: true,
                    showLine: true,
                },
                {
                    label: 'Limite Inf',
                    data: dataToChart.sensorMaxThresholdValues,
                    borderColor: 'rgba(0, 179, 52)',
                    backgroundColor: 'rgba(0, 179, 52)',
                    borderDash: [15, 3, 3, 3],
                    lineTension: 0.5,
                    borderWidth: 0.8,
                    pointStyle: false,
                    fill: false,
                },
                {
                    label: 'Limite Sup',
                    data: dataToChart.sensorMinThresholdValues,
                    borderColor: 'rgba(0, 179, 52)',
                    backgroundColor: 'rgba(0, 179, 52)',
                    borderDash: [15, 3, 3, 3],
                    lineTension: 0.5,
                    borderWidth: 0.8,
                    pointStyle: false,
                    fill: false,
                },
            ]);
        } else if (type === "portAndAC" && sensorName === "portAndAcFarm") {
            setDatasets([
                {
                    label: 'Porta Aberta',
                    data: dataToChart.sensor32Values,
                    borderColor: 'rgb(229, 229, 229)',
                    backgroundColor: 'rgb(229, 229, 229)',
                    pointStyle: false,
                    borderWidth: 0.5,
                    spanGaps: false,
                },
                {
                    label: 'Ar Condicionado Desligado',
                    data: dataToChart.sensor12Values,
                    borderColor: 'rgb(229, 229, 229)',
                    backgroundColor: 'rgb(229, 229, 229)',
                    pointStyle: false,
                    borderWidth: 0.5,
                    spanGaps: false,
                },
                {
                    label: '',
                    data: dataToChart.sensor11Values,
                    borderColor: 'rgb(229, 229, 229)',
                    backgroundColor: 'rgb(229, 229, 229)',
                    pointStyle: 'line',
                    borderWidth: 0.5,
                    spanGaps: false,
                },
                {
                    label: '',
                    data: dataToChart.sensor31Values,
                    borderColor: 'rgb(229, 229, 229)',
                    backgroundColor: 'rgb(229, 229, 229)',
                    pointStyle: 'line',
                    borderWidth: 0.5,
                    spanGaps: false,
                },

                {
                    label: 'Ar-Condicionado Ligado',
                    data: dataToChart.sensor1Values,
                    borderColor: 'rgb(220, 120, 0)',
                    backgroundColor: 'rgb(220, 120, 0)',
                    pointStyle: 'line',
                    borderWidth: 1.5,
                    spanGaps: false,

                },
                {
                    label: 'Porta Fechada',
                    data: dataToChart.sensor3Values,
                    borderColor: 'rgb(12, 100, 0)',
                    backgroundColor: 'rgb(12, 100, 0)',
                    pointStyle: 'line',
                    borderWidth: 2,
                    spanGaps: false,
                },

            ]);
        }

        setLoadingChart(false);
    }, [dataToChart]);

    if (!loadingChart) {
        return (
            <LineChartDetailsCardReport
                labels={dataToChart.labels}
                datasets={datasets}
                height={height}
                key={key}
                type={type}
                local={local}
                sensorName={sensorName}
            />
        );
    }
}

